import React from 'react';
const ProfileCard = ({ speakerInfo, forDesktop }) => {
   
    return (
        <div className="m-2">
            <div className="d-flex justify-content-center">
                <div className="speaker-card ">

                    <img src={speakerInfo?.img1?.url} className="img-fluid" alt="" />

                    <div className="ms-2 d-flex flex-column justify-content-center ">
                        <h5 className="reg-title ">{speakerInfo?.name}</h5>
                        <p className="reg-description m-0">{speakerInfo?.designation}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileCard;